import { useTranslation, Trans } from "react-i18next";
import { useAuth } from "../../auth/AuthContext";
import { HeroCarousel } from "../../components/common/HeroCarousel";
import { TopNav } from "../../components/nav/TopNav";
import "./Hero.less";

function looksLikeEmail(s: string): boolean {
  return s.includes("@") || s.includes(".");
}

function firstName(user: { name?: string } | null): string | null {
  const name = user?.name?.trim();
  if (name && !looksLikeEmail(name)) return name.split(/\s+/)[0];
  return null;
}

export function Hero() {
  const { user } = useAuth();
  const { t } = useTranslation("trips");
  const name = firstName(user);

  return (
    <section className="home-hero" data-testid="home-hero">
      <HeroCarousel folder="main" />
      <div className="home-hero__scrim" data-testid="home-hero-scrim" />
      <TopNav overlay />
      <div className="home-hero__inner">
        <div className="home-hero__content">
          <h1 className="home-hero__title">
            {user ? (
              <Trans
                i18nKey="hero.whereToNextName"
                ns="trips"
                values={{ name: name || t("hero.traveler") }}
                components={{ em: <em /> }}
              />
            ) : (
              t("hero.whereToNext")
            )}
          </h1>
          <p className="home-hero__sub">{t("hero.lede")}</p>
        </div>
      </div>
    </section>
  );
}
